import styled from 'styled-components';

import Text from '../Text';

const TextWrapper = styled(Text)`
  text-align: center;
`;

export default TextWrapper;
